import {
  Button,
  IconWrapper,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as ArrowRight } from "@king-ict/eupisi-ui/components/Icon/ArrowRight.svg";
import { Col } from "react-bootstrap";

export const renderOibServiceInfoComponent = ({
  message = "",
  clickHandler,
  currentValue = "",
  oibValue = "",
}: {
  message?: string | null;
  clickHandler: () => void;
  currentValue?: string | number | Date | null;
  oibValue?: string | number | Date | null;
}) => {
  const isDisabled =
    currentValue === oibValue ||
    (currentValue instanceof Date &&
      oibValue instanceof Date &&
      currentValue.getTime() === oibValue.getTime());

  return (
    <Col className="flex px-0">
      <Button
        outline={true}
        size="sm"
        onClick={clickHandler}
        disabled={isDisabled}
        className="mr-2"
      >
        <IconWrapper color="primary">
          <ArrowRight />
        </IconWrapper>
      </Button>
      <Typography
        color="primary"
        component="span"
        className={isDisabled ? "opacity-50" : ""}
      >
        {message}
      </Typography>
    </Col>
  );
};
